import { Badge, Card, Col, OverlayTrigger, Popover, Row, Table, Tooltip } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import { DEV_SERVER } from "../../../constants/urls";
import { toast } from "react-toastify";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { userSignal } from "../../../signal/userSignal";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import * as moment from "moment";
import DataTable from "react-data-table-component";
import avatar1 from "../../../assets/images/avatars/01.png"
import { useNavigate, useSearchParams } from "react-router-dom";
import AddEmployeeModal from "./AddEmployee";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import EditEmployeeModal from "./EditEmployee";
import { allUsersSignal } from "../../../signal/allUsersSignal";
import { organisationSignal } from "../../../signal/organisationSignal";


export default function EmployeeList() {

    const navigate = useNavigate();

    const [searchParams, setSearchParams] = useSearchParams();
    const [employees, setEmployees] = useState([]);
    const [employeeToDisplay, setEmployeeToDisplay] = useState([]);
    const [search, setSearch] = useState("");
    const [addEmployeeModalShow, setAddEmployeeModalShow] = useState(false);
    const [editEmployeeModalShow, setEditEmployeeModalShow] = useState(false);
    const [selectEmployee, setSelectEmployee] = useState(null);
    const [statusFilter, setStatusFilter] = useState("enable"); // 'enable', 'disable', 'all'

    useEffect(() => {
        setEmployeeToDisplay(employees.filter((item) => {
            if (search === "") return true;
            if (item?.state?.toLowerCase().includes(search.toLowerCase())) return true;
            if (item.name.toLowerCase().includes(search.toLowerCase())) return true;
            if (item.phoneNumber.toString().toLowerCase().includes(search.toLowerCase())) return true;
            if (item.userType.toLowerCase().includes(search.toLowerCase())) return true;
            if (item.isTallySyncMaster === true && "tally sync master".includes(search.toLowerCase())) return true;
            if (item.isAdmin === true && "super admin".includes(search.toLowerCase())) return true;
            if (item.isAdmin === false && "manager".includes(search.toLowerCase())) return true;
            if (item.group?.toLowerCase().includes(search.toLowerCase())) return true;
            return false;
        }))
    }, [search, employees])


    const sendNotificationToUser = useMutation((data) => axios.post(`${DEV_SERVER}/trip/v2/testNotification`, data, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`,
        },
    }), {
        onSuccess: (data) => {
            if (data.data.status) {
                toast.success(data.data.message);
            } else {
                toast.error(data.data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            }
        }
    })

    const getEmployees = useQuery(["employees", statusFilter], async () => {
        let resp = await axios.get(`${DEV_SERVER}/auth/v2/employee/getEmployees?status=${statusFilter}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },

        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {

                let stateName = window.localStorage.getItem("state");
                let tempEmp = []
                let temp = {}
                data.data.map((item) => {
                    temp[item.id] = item
                    if (stateName) {
                        if (item?.state === stateName) {
                            tempEmp.push(item)
                        }
                    } else {
                        tempEmp.push(item)
                    }
                })
                setEmployees(tempEmp)
                allUsersSignal.value = temp
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    const refetchEmployees = () => {
        getEmployees.refetch({ cancelRefetch: true });
    }

    const deleteEmployee = useMutation((id) => axios.delete(`${DEV_SERVER}/auth/v2/employee/${id}`, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`,
        },
    }), {
        onSuccess: (data) => {
            if (data.data.status) {
                toast.success(data.data.message);
                refetchEmployees();
            } else {
                toast.error(data.data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            }
        }
    })

    const disableEmployee = useMutation((id) => axios.put(`${DEV_SERVER}/auth/v2/employee/disable/${id}`, {}, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`,
        },
    }), {
        onSuccess: (data) => {
            if (data.data.status) {
                toast.success(data.data.message);
                refetchEmployees();
            } else {
                toast.error(data.data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Failed to disable employee");
            }
        }
    })

    const enableEmployee = useMutation((id) => axios.put(`${DEV_SERVER}/auth/v2/employee/enable/${id}`, {}, {
        headers: {
            Authorization: `Bearer ${userSignal.value?.token}`,
        },
    }), {
        onSuccess: (data) => {
            if (data.data.status) {
                toast.success(data.data.message);
                refetchEmployees();
            } else {
                toast.error(data.data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Failed to enable employee");
            }
        }
    })

    const handleEmployeeDelete = (id) => {
        confirmAlert({
            title: 'Confirm to delete',
            message: 'Are you sure you want to delete this employee?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => deleteEmployee.mutate(id)
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        })
    }

    const handleEmployeeDisable = (id) => {
        confirmAlert({
            title: 'Confirm to disable',
            message: 'Are you sure you want to disable this employee?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => disableEmployee.mutate(id)
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        })
    }

    const handleEmployeeEnable = (id) => {
        confirmAlert({
            title: 'Confirm to enable',
            message: 'Are you sure you want to enable this employee?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => enableEmployee.mutate(id)
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        })
    }

    const handleSendNotification = (fcmToken, title) => {
        let data = {
            fcmToken: fcmToken,
            title: title,
        }

        sendNotificationToUser.mutate(data);
    }

    useEffect(() => {
        refetchEmployees()
    }, [])

    useEffect(() => {
        refetchEmployees()
    }, [statusFilter])

    const columns = [
        {
            name: "Profile",
            color: true,
            selector: (row) => {
                return <Zoom><img onClick={() => navigate(`/dashboard/users/${row?.id}`)} onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ pointerEvents: "none", width: "50px", height: "50px", borderRadius: "50%", margin: "0.5rem 0rem", border: "1px solid black" }} src={row?.profileURL !== "" ? row?.profileURL : avatar1} /></Zoom>
            },
        },
        {
            name: "Name",
            color: true,
            selector: (row) => {
                return <p onClick={() => navigate(`/dashboard/users/${row?.id}`)} style={{ margin: "0px", }}>{row?.name}</p>
            },
            width: "200px"
        },
        {
            name: "PhoneNumber",
            color: true,
            selector: (row) => {
                return <p onClick={() => navigate(`/dashboard/users/${row?.id}`)} style={{ margin: "0px", }}>{row?.phoneNumber}</p>
            }
        },
        {
            name: "Type",
            color: true,
            selector: (row) => {
                const getBadgeColor = () => {
                    if (row?.userType === "employee") return "info";
                    if (row?.userType === "officestaff") return "secondary";
                    if (row?.isAdmin) {
                        return row?.isTallySyncMaster ? "secondary" : "primary";
                    }
                    return "success";
                };

                const getDisplayText = () => {
                    if (row?.userType === "employee") return row?.userType;
                    if (row?.userType === "officestaff") return "Office Staff";
                    if (row?.isAdmin) {
                        return row?.isTallySyncMaster ? "Sync Master" : "Super Admin";
                    }
                    return "Manager";
                };

                return (
                    <Badge
                        onClick={() => navigate(`/dashboard/users/${row?.id}`)}
                        bg={getBadgeColor()}
                    >
                        {getDisplayText()}
                    </Badge>
                );
            },
        },
        {
            name: "Group",
            selector: "group"
        },
        {
            name: "Designation",
            selector: "designation",
        },
        {
            name: "Password",
            width: "150px",
            color: true,
            selector: (row) => {
                return <span style={{ display: "flex", alignItems: "center", columnGap: "0.5rem" }}>
                    <p style={{ margin: "0px" }}>{row?.password}</p>
                    <OverlayTrigger trigger="click" placement="top" rootClose overlay={<Popover id="popover-basic"><Popover.Header as="h3">Copied</Popover.Header></Popover>}>
                        <i onClick={() => navigator.clipboard.writeText(row?.password)} style={{ cursor: "pointer" }} class="fas fa-copy"></i>
                    </OverlayTrigger>
                </span>
            }
        },
        {
            name: "State",
            color: true,
            selector: "state",
            cell: (row) => {
                return <p onClick={() => navigate(`/dashboard/users/${row?.id}`)} style={{ margin: "0px", }}>{row?.state?.toUpperCase()}</p>
            }
        },
        {
            name: "Action",
            selector: (row) => <>{(row?.id !== userSignal.value?.user?.id && !row?.isTallySyncMaster) && <div style={{ display: "flex", columnGap: "0.5rem", flexWrap: "wrap" }}>
                <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Edit</Tooltip>}>
                    <span style={{ cursor: "pointer" }} onClick={() => {
                        setSelectEmployee(row);
                        setEditEmployeeModalShow(true);
                    }}><i className="far fa-edit table-icons"></i></span>
                </OverlayTrigger>
                {!row?.isDeleted && (
                    <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Disable</Tooltip>}>
                        <span style={{ cursor: "pointer" }} onClick={() => {
                            handleEmployeeDisable(row?.id)
                        }}><i className="fas fa-ban table-icons" style={{ color: "#ffc107" }}></i></span>
                    </OverlayTrigger>
                )}
                {row?.isDeleted && (
                    <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Enable</Tooltip>}>
                        <span style={{ cursor: "pointer" }} onClick={() => {
                            handleEmployeeEnable(row?.id)
                        }}><i className="fas fa-check-circle table-icons" style={{ color: "#28a745" }}></i></span>
                    </OverlayTrigger>
                )}
                <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Delete</Tooltip>}>
                    <span style={{ cursor: "pointer" }} onClick={() => {
                        handleEmployeeDelete(row?.id)
                    }}><i className="far fa-trash-alt table-icons"></i></span>
                </OverlayTrigger>
            </div>}</>
        }
    ]

    if (organisationSignal.value?.autoTripStartEnabled) {
        columns.push({
            name: "Notifiy",
            selector: (row) => <div style={{ display: "flex", columnGap: "0.5rem", flexWrap: "wrap" }}>
                <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>Start Trip</Tooltip>}>
                    <span style={{ cursor: "pointer", opacity: sendNotificationToUser?.isLoading ? "0.5" : "1", pointerEvents: sendNotificationToUser?.isLoading ? "none" : "unset" }} onClick={() => {
                        handleSendNotification(row?.fcmToken, "trip-start")
                    }}><i className="fa fa-plane table-icons"></i></span>
                </OverlayTrigger>
                <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>End Trip</Tooltip>}>
                    <span style={{ cursor: "pointer", opacity: sendNotificationToUser?.isLoading ? "0.5" : "1", pointerEvents: sendNotificationToUser?.isLoading ? "none" : "unset" }} onClick={() => {
                        handleSendNotification(row?.fcmToken, "trip-end")
                    }}><i className="fa fa-plane-slash table-icons"></i></span>
                </OverlayTrigger>
            </div>
        })
    }

    // useEffect(() => {
    //     getEmployees.refetch({ cancelRefetch: true });
    // }, [fromDate, toDate])

    return (
        <>
            <div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">Employee List</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", columnGap: "1rem", marginBottom: "1rem", flexWrap: "wrap" }}>
                                    <div style={{ display: "flex", alignItems: "flex-end", columnGap: "1rem", flexWrap: "wrap" }}>
                                        <div>
                                            <label htmlFor="search">Search</label>
                                            <input type="search" id="search" defaultValue={search} className="form-control vanila-datepicker" names="start" placeholder="Search anything..." onChange={(e) => {
                                                setSearch(e.target.value)
                                            }} />
                                        </div>
                                        <div>
                                            <label htmlFor="statusToggle">Show Disabled Employees</label>
                                            <div className="form-check form-switch" style={{ fontSize: "1.2rem", paddingLeft: "2.5rem" }}>
                                                <input 
                                                    className="form-check-input" 
                                                    type="checkbox" 
                                                    id="statusToggle"
                                                    checked={statusFilter === 'disable'}
                                                    onChange={(e) => setStatusFilter(e.target.checked ? 'disable' : 'enable')}
                                                    style={{ cursor: "pointer", width: "3rem", height: "1.5rem" }}
                                                />
                                                <label className="form-check-label ms-2" htmlFor="statusToggle" style={{ cursor: "pointer", userSelect: "none" }}>
                                                    {statusFilter === 'disable' ? 
                                                        <><i className="fas fa-ban me-1" style={{ color: "#ffc107" }}></i>Disabled</> : 
                                                        <><i className="fas fa-check-circle me-1" style={{ color: "#28a745" }}></i>Enabled</>
                                                    }
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <button className="btn btn-primary" onClick={() => setAddEmployeeModalShow(true)}>
                                        <i className="fas fa-plus"></i>
                                        <span className="ms-1">Add Employee</span>
                                    </button>
                                </div>
                                {(!getEmployees.isLoading && !getEmployees?.isFetching) && <DataTable
                                    customStyles={{ rows: { style: { cursor: "pointer" } } }}
                                    onRowClicked={(row, e) => {
                                        if (row?.isTallySyncMaster) {
                                            return
                                        }
                                        navigate(`/dashboard/users/${row?.id}`)
                                    }}
                                    columns={columns}
                                    data={employeeToDisplay}
                                    pagination={true}
                                    paginationPerPage={35}
                                    paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 35]}
                                    paginationDefaultPage={searchParams.get("page") ? parseInt(searchParams.get("page")) : 1}
                                    onChangeRowsPerPage={(e, page) => {
                                        let currentSearchParam = searchParams
                                        currentSearchParam.set("perPage", e)
                                        setSearchParams(currentSearchParam)
                                    }}
                                    onChangePage={(page) => {
                                        let currentSearchParam = searchParams
                                        currentSearchParam.set("page", page)
                                        setSearchParams(currentSearchParam)
                                    }}
                                />}
                                {(getEmployees.isLoading || getEmployees?.isFetching) && <div className="d-flex justify-content-center">
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
            {addEmployeeModalShow && <AddEmployeeModal show={addEmployeeModalShow} refetchEmployees={refetchEmployees} close={() => setAddEmployeeModalShow(false)} />}
            {editEmployeeModalShow && <EditEmployeeModal show={editEmployeeModalShow} refetchEmployees={refetchEmployees} close={() => setEditEmployeeModalShow(false)} employee={selectEmployee} />}
        </>
    )
}